'use strict';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/all';
import { on, throttle } from './modules/_fn';
import { useHeader } from './components/header';
import { useAOS } from './modules/_utils';
import { openModal, closeModal, useModalControl } from './components/modal';
import { useBreadcrumb } from './components/breadcrumb';
import { useFormError, removeFormError, usePlainCode } from './components/form'
import { useDropdown } from './components/dropdown'

window.openModal = openModal
window.closeModal = closeModal
window.useFormError = useFormError
window.removeFormError = removeFormError

gsap.registerPlugin(ScrollToPlugin)

/* ---------------------------------------- [START] IE Global Setting */
// 舊IE提醒
const userAgent = window.navigator.userAgent;
if (
	userAgent.indexOf('MSIE 7.0') > 0 ||
	userAgent.indexOf('MSIE 8.0') > 0 ||
	userAgent.indexOf('MSIE 9.0') > 0 ||
	userAgent.indexOf('MSIE 10.0') > 0 ||
	!!userAgent.match(/Trident.*rv\:11\./) // IE11
) {
	location.href = '/browser.html';
}
/* ---------------------------------------- [END] IE Global Setting */

/* ---------------------------------------- [START] Document Ready */
(function (window, document) {
	/* ---------------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	const body = document.body || document.querySelector('body');
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}
	on(window, 'load', getWinSet);
	on(window, 'resize', throttle(getWinSet, 50, 100));
	/* ---------------------------------------- [END] Windows Setting */

	/* ---------------------------------------- [START] 取得裝置判斷 */
	// 取得裝置判斷
	let isMobile = false;
	let isTablet = false;
	let isPhone = false;

	const deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if (isMobile) html.classList.add('is-mobile');
		else html.classList.remove('is-mobile');

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true;
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true;
		}
	};

	deviceDetect();
	on(window, 'resize', throttle(deviceDetect, 50, 100));
	/* ---------------------------------------- [END] 取得裝置判斷 */

	/* ---------------------------------------- [START] 判斷browser */
	var ua = navigator.userAgent;
	var browser = {
		isChrome: /chrome/i.test(ua),
		isFirefox: /firefox/i.test(ua),
		isSafari: /safari/i.test(ua),
		isIE: /msie/i.test(ua) || /trident/i.test(ua),
		isEdge: /edge/i.test(ua),
	};

	// 修正數值browser
	if (browser.isChrome) browser.isSafari = false;
	if (browser.isEdge) {
		browser.isChrome = false;
		browser.isSafari = false;
	}

	var browserIs;
	for (var key in browser) {
		if (browser[key]) {
			browserIs = key.split('is')[1];
			// 增加Class
			document.documentElement.classList.add(browserIs.toLowerCase());
			document.documentElement.browser = browserIs;
			break;
		}
	}
	browser.is = browserIs;

	// ----------------------------
	// 判斷 裝置
	// iOS
	var isiOS = ua.toLowerCase().match(/(iphone|ipod|ipad)/);
	isiOS && html.classList.add('ios');
	/* ---------------------------------------- [END] 判斷browser */

	/* ----------------------------------- [START] Loader 移除 */
	var loaderRemove = function () {
		var loader = document.querySelector('#loader');
		window.loader = loader; // 加到 window 上

		pageLoaded();
	};
	on(window, 'load', loaderRemove);

	/* 頁面可呼叫的 function -------- */
	/* 開啟 Loading */
	window.pageLoading = function () {
		if (!loader) return;
		loader.classList.remove('loaded');
		document.body.appendChild(loader);
	}

	/* 關閉 Loading */
	window.pageLoaded = function () {
		if (!loader) return;
		setTimeout(() => {
			loader.classList.add('loaded');
			setTimeout(() => {
				loader.remove();
			}, 600);
		}, 1800);
	}
	/* ----------------------------------- [END] Loader 移除 */

	/* ---------------------------------------- [START] LazyLoad */
	/*
	 * 使用：https://github.com/verlok/vanilla-lazyload
	 * 尋找頁面上的 .lazy 為執行 Lazy Load 物件
	 */
	var lazyloadTimer = 0;
	function buildLazyLoad() {
		if (lazyloadTimer < 5 && window.LazyLoad === undefined) {
			return setTimeout(function () {
				lazyloadTimer++;
				buildLazyLoad();
			}, 500);
		}

		var lazyLoadInstance = new LazyLoad({
			// Your custom settings go here
		});
	}
	on(window, 'load', buildLazyLoad);
	/* ---------------------------------------- [END] LazyLoad */

	// /* ---------------------------------------- [START] Fetch Svg Inline */
	// function buildSvgFetchInline() {
	// 	if (fetchSvgInline === undefined) {
	// 		return false
	// 	}

	// 	const svgImgs = document.querySelectorAll('img.svg');
	// 	[].forEach.call(svgImgs, (svg) => {
	// 		fetchSvgInline(svg)
	// 	});
	// }
	// on(window, 'load', buildSvgFetchInline);
	// /* ---------------------------------------- [END] Fetch Svg Inline */

	// /* ----------------------------------- [START] Foundation */
	on(window, 'load', function () {
		// Start
		$(document).foundation();
	});
	// /* ----------------------------------- [END] Foundation */

	// /* ---------------------------------------- [START] ScrollTriggerAni */
	// // 有滑動到該區增加動態者增加class "js-ani" ， 滑動到該區增加class "is-animated"
	// let aniSec = document.querySelectorAll('.js-ani');
	// const scrollTriggerAniThrottle = throttle(scrollTriggerAni, 200, 500); // 節流作用

	// function scrollTriggerAni() {
	// 	for (var i = 0; i < aniSec.length; i++) {
	// 		if (isInViewport(aniSec[i])) {
	// 			aniSec[i].classList.add('is-animated');
	// 		}
	// 	}

	// 	cleanTrigger();

	// 	/* If load all of the item, stop Listener */
	// 	if (aniSec.length === 0) {
	// 		window.addEventListener('scroll', scrollTriggerAniThrottle);
	// 	}
	// }

	// function cleanTrigger() {
	// 	aniSec = Array.prototype.filter.call(aniSec, function (ani) {
	// 		return !ani.classList.contains('is-animated');
	// 	});
	// }

	// function isInViewport(el) {
	// 	const rect = el.getBoundingClientRect();
	// 	const isVisible = el.offsetHeight !== 0;

	// 	return (
	// 		isVisible &&
	// 		rect.bottom >= 0 &&
	// 		rect.right >= 0 &&
	// 		rect.top + 100 <= (window.innerHeight || document.documentElement.clientHeight) &&
	// 		rect.left <= (window.innerWidth || document.documentElement.clientWidth)
	// 	);
	// }

	// on(window, 'load', scrollTriggerAni);
	// on(window, 'scroll', scrollTriggerAniThrottle);
	// /* ---------------------------------------- [END] ScrollTriggerAni */

	const useGoToTopBtn = () => {
		const btn = document.querySelector('#gototop')
		if (!btn) return;

		btn.addEventListener('click', () => {
			gsap.to(window, {duration: 1, scrollTo: 0})
		})
	}

	// 全站 cookie 提示
	const useCookie = () => {
		const cookie = document.querySelector('aside.cookie')
		const isChecked = localStorage.getItem('is-checked')
		if (!cookie || isChecked) return;

		const cookieBtn = cookie.querySelector('#cookie-confirm')
		cookie.classList.add('is-show')
		cookieBtn.addEventListener('click', () => {
			cookie.classList.add('is-hide')
			localStorage.setItem('is-checked', true)
		})
	}

	// login 紀錄帳號
	const useLoginAccountStore = () => {
		const loginAccountCheck = document.querySelector('#login-account-checkbox')
		const loginAccountInput = document.querySelector('#login-account-input')
		const loginCodeInput = document.querySelector('#login-code-input')
		if (!loginAccountCheck || !loginAccountInput) return;

		const checkHandler = () => {
			if (loginAccountCheck.checked) {
				localStorage.setItem('sunmax-remember', true)
				loginAccountInput.addEventListener('input', storeAccount)
				loginCodeInput.addEventListener('change', storeAccount)
			}
			else {
				localStorage.removeItem('sunmax-remember')
				loginAccountInput.removeEventListener('input', storeAccount)
				loginCodeInput.removeEventListener('change', storeAccount)
			}
			storeAccount()
		}

		const storeAccount = () => {
			if (loginAccountCheck.checked) {
				localStorage.setItem('sunmax-account', loginAccountInput.value)
				localStorage.setItem('sunmax-code', loginCodeInput.value)
			}
			else {
				localStorage.removeItem('sunmax-account')
				localStorage.removeItem('sunmax-code')
			}
		}

		const getStoreAccount = () => {
			const isRemember = localStorage.getItem('sunmax-remember')
			if (isRemember) {
				loginAccountCheck.checked = true
				const storeAccount = localStorage.getItem('sunmax-account')
				const storeCode = localStorage.getItem('sunmax-code')

				if (storeAccount) {
					loginAccountInput.value = storeAccount
				}
				if (storeCode) {
					loginCodeInput.value = storeCode
				}
			}
		}

		getStoreAccount()
		checkHandler()
		loginAccountCheck.addEventListener('change', checkHandler)
	}

	// 閒置逾時提醒及登出
	// window.useLogout = () => { console.log('logout') }
	const useTimeoutLogout = () => {
		if (!window.isAuthenticated) return;

		const timeoutModal = document.querySelector('#timeout-modal')
		if (!timeoutModal) return;

		const timeoutPopupSpan = timeoutModal.querySelector('.timeout-popup')
		const timeoutLogoutSpan = timeoutModal.querySelector('.timeout-logout')

		const timeoutPopupTime = Number(timeoutModal.getAttribute('data-timeout-popup')) || 15 // 分鐘
		const timeoutLogoutTime = Number(timeoutModal.getAttribute('data-timeout-logout')) || 15 // 秒
		let logoutCountdown = timeoutLogoutTime

		timeoutPopupSpan && (timeoutPopupSpan.textContent = timeoutPopupTime)
		timeoutLogoutSpan && (timeoutLogoutSpan.textContent = timeoutLogoutTime)

		if (timeoutPopupSpan && timeoutLogoutSpan) {
			let popupTimer
			let logoutTimer
			let countdownTimer

			const setCountdown = () => {
				logoutCountdown--
				timeoutLogoutSpan && (timeoutLogoutSpan.textContent = logoutCountdown)
			}

			const resetTimer = () => {
				clearTimeout(popupTimer)
				clearTimeout(logoutTimer)
				if (timeoutModal.classList.contains('is-show')) {
					closeModal('#timeout-modal')
					clearInterval(countdownTimer)
					logoutCountdown = timeoutLogoutTime
				}
				popupTimer = setTimeout(() => {
					openModal('#timeout-modal')
					countdownTimer = setInterval(setCountdown, 1000)
				}, timeoutPopupTime * 60 * 1000)
				logoutTimer = setTimeout(() => {
					closeModal('#timeout-modal')
					openModal('#logout-modal')
					clearInterval(countdownTimer)
					useLogout()
				}, (timeoutPopupTime * 60 + timeoutLogoutTime) * 1000)
			}

			document.addEventListener('mousemove', resetTimer)
		}
	}

	/* ---------------------------------------- [START] 選單下滑更改樣式 */
	useModalControl();
	useHeader();
	useAOS();
	useBreadcrumb();
	usePlainCode();
	useGoToTopBtn();
	useCookie();
	useLoginAccountStore();
	useTimeoutLogout();
	useDropdown();
	/* ---------------------------------------- [END] 選單下滑更改樣式 */
})(window, document);
/* ---------------------------------------- [END] Document Ready */
